import { ContentCountInput } from 'screens/Schedule/EditChannelsModal/ContentCountInput'
import { PostTypeCountInputProps } from 'screens/Schedule/EditChannelsModal/Types'
import { usePostTypeField } from 'screens/Schedule/EditChannelsModal/usePostTypeField'

export type { PostTypeCountInputProps }

export const PostTypeCountInput = ({ name, postType, accountId, contentType, ...props }: PostTypeCountInputProps) => {
  const [field] = usePostTypeField({ name, postType, accountId, contentType })

  return <ContentCountInput name={field.name} {...props} />
}
